<template>
    <b-modal id="scretDictionaryDetailModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">{{title}} 상세</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><span>{{scretDictionaryData.prescribe_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td><span>{{scretDictionaryData.prescribe_category_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>출전</th>
                                <td><span>{{scretDictionaryData.prescribe_source}}</span></td>
                            </tr>
                            <tr>
                                <th>처방구성</th>
                                <td><span>{{scretDictionaryData.prescribe_medicine}}</span></td>
                            </tr>
                            <tr>
                                <th>적응증</th>
                                <td><span>{{scretDictionaryData.indications}}</span></td>
                            </tr>
                            <tr>
                                <th>처방설명 및 가감</th>
                                <td><span>{{scretDictionaryData.secret_prescription_adjust}}</span></td>
                            </tr>
                            <tr>
                                <th>참고사항</th>
                                <td><span>{{scretDictionaryData.remarks}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="title_sm">
                        <h3 class="tb_title">비방 사전 리뷰</h3>
                        <div class="flex items-center gap4">
                            평균 별점 :
                            <div>
                            <StarRating :rating="scretDictionaryData.avgStarRate" />
                            </div>
                        </div>
                    </div>
                    <div
                    class="review-table-wrapper"
                    :class="{ scrollable: scretDictionaryData.reviewList.length == 0 }"
                    >
                        <table class="list">
                            <colgroup>
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                            </colgroup>
                            <tbody>
                                <tr>
                                <th>답변자</th>
                                <th>평가</th>
                                <th>별점</th>
                                </tr>

                                <tr v-if="scretDictionaryData.reviewList.length == 0">
                                    <td colspan="3"><span>데이터가 없습니다.</span></td>
                                </tr>
                                <tr v-for="(item, index) in scretDictionaryData.reviewList"
                                    :key="index"
                                >
                                    <td><span>{{item.review_user}}</span></td>
                                    <td><span>{{item.review_content}}</span></td>
                                    <td>
                                        <StarRating :rating="item.star_rating" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>

    import StarRating from "@/components/common/StarRating.vue";

    export default {
        name: 'dictionaryDetailModal',
        components: {
            StarRating
        },
        props: {
            title: String,
            scretDictionaryData : {
                prescribe_nm : '',
                prescribe_source : '',
                prescribe_medicine : '',
                prescribe_category : '',
                prescribe_category_nm : '',
                indications : '',
                secret_prescription_adjust : '',
                remarks : '',
                item : {},
                avgStarRate : 0,
                reviewList : []
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.scretDictionaryData.item);
            }          
        },
        data () {
            return {
            }
        }
    }
</script>

<style>

</style>